export default __webpack_public_path__ + "static/2021-91efcfbb9d4b8c68c684cf83c197b6ea.svg";